// extracted by css-extract-rspack-plugin
module.exports =  {"custom_step_announcement_modal":"CustomStepAnnouncementModal_custom_step_announcement_modal__qn8t7"};